import { Fragment, useEffect } from "react"
import { Container, Table, Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Spinner } from "react-bootstrap"
import { getAnomalyTable } from "../anomalyRegistration/anomalyApi"
import React from "react"

export function AnomalyTable(props) {
    const log = useSelector((state) => state.login)
    const user = useSelector((state) => state.user)
    const anomaly = useSelector((state) => state.anomaly)
    const dispatch = useDispatch()
    let info = (<Fragment>
        <Spinner animation="border" />
    </Fragment>)
    if (anomaly.table != null && anomaly.table.length > 0) {
        const rows = anomaly.table.map((row, index) => (
            <tr key={index} >
                <td key={index + row.username}>{row.username} </td>
                <td key={index + row.count}>{row.count}</td>
            </tr>))
        info = (<Table className="table table-sm table-hover">
            <thead>
                <tr>
                    <th>Пользователь</th>
                    <th>Количество аномалий</th>

                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>)


    }else{
        setTimeout(() => dispatch(getAnomalyTable(log.token)), 1000);
    }
    return (
        <Fragment>
            <div className="table-responsive-sm">
            {info}
            </div>

        </Fragment>
    )
}
